import { Auth0DecodedHash, Auth0Error, WebAuth } from 'auth0-js';

import config from './config';

export class AuthClient {
  webAuth = new WebAuth({
    domain: config.domain,
    clientID: config.clientId,
    responseType: config.responseType,
    scope: config.scope,
    universalLoginPage: true,
    audience: config.audience,
    overrides: {
      __tenant: config.tenant,
      __token_issuer: config.tokenIssuer,
    },
  });

  authorize(): void {
    this.webAuth.authorize({
      audience: config.audience,
      domain: config.domain,
      redirectUri: window.location.origin,
      responseType: config.responseType,
      connection: config.realm,
      prompt: 'login',
    });
  }

  signOut(): void {
    this.webAuth.logout({
      clientID: config.clientId,
      returnTo: `${window.location.origin}/login`,
    });
  }

  checkSession(callback: (error: Auth0Error | null, response: Auth0DecodedHash | null) => void): void {
    this.webAuth.checkSession(
      {
        audience: config.audience,
        domain: config.domain,
        redirectUri: window.location.origin,
        responseType: config.responseType,
        connection: config.realm,
      },
      callback,
    );
  }

  authorizeMfa(): void {
    this.webAuth.authorize({
      audience: config.mfaUrl,
      scope: config.mfaScope,
      clientID: config.clientId,
      responseType: config.responseType,
      redirectUri: `${window.location.origin}/profile/account?${this.getMfaActionQueryParam().combined}`,
    });
  }

  renewAuth(): void {
    this.webAuth.renewAuth(
      {
        audience: config.audience,
        domain: config.domain,
        redirectUri: window.location.origin,
        responseType: config.responseType,
        usePostMessage: true,
      },
      () => void 0,
    );
  }

  getMfaActionQueryParam(): { key: string; value: string; combined: string } {
    const key = 'action';
    const value = 'mfa';
    const combined = `${key}=${value}`;
    return { key, value, combined };
  }

  parseHash(): Promise<{ accessToken: string; idToken: string }> {
    return new Promise((resolve, reject) => {
      this.webAuth.parseHash((error, result) => {
        if (error || !result?.accessToken || !result?.idToken) {
          const message = 'Error parsing hash';
          console.error(message, { error });
          reject(new Error(message));
        } else {
          resolve({ accessToken: result.accessToken, idToken: result.idToken });
        }
      });
    });
  }
}

const client = new AuthClient();

export default client;
